
<!-- global router -->
<router-outlet></router-outlet>

<!-- global loader -->
<app-loader></app-loader>
